import React, { useState, useEffect, forwardRef } from "react";
import clsx from 'clsx';
import { compose } from "redux";
import { NavLink, withRouter } from "react-router-dom";
import { HashLink, NavHashLink } from 'react-router-hash-link';
import {
  SwipeableDrawer, IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import MybilioTextLogoBronze from "../../../resources/logo/mybilio_text_logo_bronze.js";
import IcClose from "../../../resources/icons/ic_close.js";

import I18n from "../../../base/i18n.js";

import Routes from "../../routes.js";

import { ProjectsAnchor } from "../../pages/index/constants.js";
import WithCurrentUser from "../../../hocs/with_current_user.js.jsx";

const blockStyles = makeStyles(theme => ({
  root: {
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    }
  },
  menu: {
    backgroundColor: theme.palette.white,
    width: "240px",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center"
  },
  close: {
    width: "24px",
    height: "24px",
    top: "32px",
    right: "16px",
    position: "absolute",
  },
  menuRow: {
    padding: "2px 24px",
    margin: "0px"
  },
  logoRow: {
    marginTop: "40px"
  },
  logo: {
    // width: "112px",
    // height: "60px"
  },
  list: {
    listStyle: "none",
    padding: "0px",
    margin: "0px"
  },
  linkRow: {
    padding: "0px 24px",
    "& + &": {
      borderTop: `1px solid ${theme.palette.grayDisable}`
    }
  },
  link: {
    display: "block",
    color: theme.palette.blueMain,
    textDecoration: "none",
    padding: "18px 24px",
    textTransform: "uppercase",
    fontSize: "16px",
    lineHeight: "20px",
    margin: "0px -24px",
    "& span": {
      display: "block"
    },
    "& span + span": {
      marginTop: "10px"
    }
  },
  linkSubtitle: {
    color: theme.palette.grayText,
    fontSize: "12px"
  },
  phone: {
    fontSize: "16px"
  },
  activeLink: {
    backgroundColor: theme.palette.grayBg
  },
}));

const LeftMenu = forwardRef((props, ref) => {
  const classes = blockStyles();
  const { onClose, menus } = props;

  const [open, setOpen] = useState(props.open);

  useEffect(() => {
    setOpen(props.open)
  }, [props.open]);

  const close = () => {
    onClose();
  }

  const onClickLink = () => {
    close();
  }

  const onClickLogOut = () => {
    const { signOut, history } = props;
    if(signOut) {
      signOut(() => {
        history.push(Routes.xavin())
      })
    }
  }

  const menuList = (menus) => {
    return menus.map(({ name, slug }) =>
      <div key={slug}>
        <li key={slug} className={ clsx(classes.menuRow, classes.linkRow) } >
          <NavHashLink to={Routes.page(slug)}
                    className = { classes.link }
                    activeClassName = { classes.activeLink }
                    onClick = { onClickLink } >
            {name}
          </NavHashLink>
        </li>
        {subMenus(slug)}
      </div>
    )
  }

  const mainMenus = (key) => {
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return menuList(filteredMenus)
  }

  const subMenus = (key) => {
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return <ul className = { clsx(classes.list, classes.linkRow) }>
             {menuList(filteredMenus)}
           </ul>
  }

  return (
    <SwipeableDrawer anchor = { "left" }
            open = { open }
            ref = { ref }
            onOpen = { () => {} }
            onClose = { close }
            className = { classes.root } >
      <div className = { classes.menu } >
        <IconButton className = { classes.close }
                    onClick = { close } >
          <IcClose />
        </IconButton>
        <div className = { clsx(classes.menuRow, classes.logoRow )} >
          <NavLink to = { Routes.xavin() }
                   onClick = { onClickLink } >
            <MybilioTextLogoBronze className = { classes.logo } />
          </NavLink>
        </div>
        <ul className = { classes.list } >
          {/* <li className = { clsx(classes.menuRow, classes.linkRow) } >
            <NavHashLink to = { Routes.index({anchor: ProjectsAnchor}) }
                      className = { classes.link }
                      activeClassName = { classes.activeLink }
                      onClick = { onClickLink } >
              { I18n.t("shared.projects") }
            </NavHashLink>
          </li> */}
          {mainMenus('main')}
          <div key={"logout"}>
            <li className={ clsx(classes.menuRow, classes.linkRow) } >
              <NavHashLink className = { classes.link }
                        activeClassName = { classes.activeLink }
                        to = { "#" }
                        onClick = { onClickLogOut } >
                { I18n.t("shared.log_out") }
              </NavHashLink>
            </li>
          </div>
        </ul>
      </div>
    </SwipeableDrawer>
  );
});

export default compose(withRouter, WithCurrentUser)(LeftMenu)
